export default {"src":"/_next/static/media/facebook-icon-black.f4ee1771.svg","height":18,"width":18};